import React from 'react';

const URL_PATTERN = '((?:https?:\\/\\/|www\\.)[^\\s<>"\'`]+)';
const TRAILING_PUNCTUATION = /[.,;:!?]+$/;

function splitUrlAndTrailing(value) {
	const match = value.match(TRAILING_PUNCTUATION);
	if (!match) {
		return { url: value, trailing: '' };
	}

	return {
		url: value.slice(0, -match[0].length),
		trailing: match[0]
	};
}

function isUrlToken(value) {
	return /^(?:https?:\/\/|www\.)[^\s<>"'`]+$/i.test(value);
}

function getHref(rawUrl) {
	const href = /^https?:\/\//i.test(rawUrl) ? rawUrl : `https://${rawUrl}`;

	try {
		const parsed = new URL(href);
		if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
			return null;
		}
		return parsed.href;
	} catch {
		return null;
	}
}

export default function LinkifyText({ text }) {
	if (text == null || text === '') {
		return null;
	}

	const parts = String(text).split(new RegExp(URL_PATTERN, 'gi'));

	return parts.map((part, index) => {
		if (!part) {
			return null;
		}

		if (!isUrlToken(part)) {
			return <React.Fragment key={index}>{part}</React.Fragment>;
		}

		const { url, trailing } = splitUrlAndTrailing(part);
		const href = url ? getHref(url) : null;

		if (!href) {
			return <React.Fragment key={index}>{part}</React.Fragment>;
		}

		return (
			<React.Fragment key={index}>
				<a
					className="linkify-text__link"
					href={href}
					target="_blank"
					rel="noopener noreferrer"
					onClick={event => event.stopPropagation()}>
					{url}
				</a>
				{trailing}
			</React.Fragment>
		);
	});
}
